function setupDeleteButtons() {
  $('.card-file .delete-button').on('click', function() {
    $(this).parent().addClass('for-deletion');
  });
}

$(document).ready(function() {

  setupDeleteButtons();

  $('.modal .modal-footer .delete-card').on('click', function() {

    if ($('.card-file-full-info').length) {
      $('.card-file.for-deletion').remove();
    } else {
      if ($('.card-file-uploaded').length > 1 || $('fieldset.service-type').length) {
        $('.card-file.for-deletion').remove();

        if (!$('fieldset.service-type .card-file').length || !$('fieldset.specialism .card-file').length) {
          $('.form-nav .bttn-submit').prop('disabled', true);
        }

        $('.modal-body input[type=checkbox], .modal input[type=radio]').prop('checked', false);
      } else {
        $('.card-file.for-deletion')
          .removeClass('card-file-image')
          .removeClass('card-file-doc')
          .removeClass('for-deletion')
          .addClass('d-none')

        $('.card-file-uploaded')
          .find('.file-size')
          .text('');
      }
      // Reset
      $('.card-file-with-input-wrapper').removeClass('d-none');
      $('.custom-file-input').val('').trigger('change');

      if ($('.file-upload-image').length) {
        $('.file-upload-image').removeClass('d-none full');
        $('.file-upload-image.active')
          .css('background-image', '')
          .css('background-size', '');
      }
    }

    setupDeleteButtons();

    if ($('.card-file-full-info').length == 0 && !$('fieldset .card-file').length && !$('fieldset.service-type').length) {
      setTimeout(function(){

        window.location = window.location.href.replace('my-', '');

      }, 150)
    } else {

    }
  });

});
